import { PropTypes } from 'prop-types';

export const videoReferencePropTypes = PropTypes.oneOfType([
  PropTypes.shape({
    matchId: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    sport: PropTypes.string.isRequired,
    track: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    matchId: PropTypes.string.isRequired,
    matchPart: PropTypes.string.isRequired,
    sport: PropTypes.string.isRequired,
    track: PropTypes.string.isRequired,
    version: PropTypes.string.isRequired,
  }),
]);

export default { videoReferencePropTypes };
